import { render } from "./VisitBranch.vue?vue&type=template&id=248a2e05&scoped=true"
import script from "./VisitBranch.vue?vue&type=script&lang=js"
export * from "./VisitBranch.vue?vue&type=script&lang=js"

import "./VisitBranch.vue?vue&type=style&index=0&id=248a2e05&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248a2e05"]])

export default __exports__